<template>
    <div v-clickaway="toggleReferralContextMenu" class="ref-context-menu-holder" :class="getClass">
        <common-icon name="dots-dark" size="medium" @click="openContextMenu"></common-icon>
        <referral-context-menu
            v-if="currentlyOpenContextMenu"
            :optionProp="option"
            :asContextMenu="true"
            @closeReferralContextMenu="toggleReferralContextMenu"
            @emitEvent="emitEvent($event, ['closeReferralContextMenu'])"
        ></referral-context-menu>
    </div>
</template>

<script>
    import ReferralContextMenu from 'components/page-elements/ReferralContextMenu'
    import ReferralContextMenuMixin from 'mixins/ReferralContextMenuMixin'

    export default {
        mixins: [ReferralContextMenuMixin],

        components: {
            ReferralContextMenu,
        },

        props: {
            referral: { type: Object, required: true },
            isDisabled: { type: Boolean, required: false, default: false },
        },

        computed: {
            getClass() {
                return {
                    'ref-context-menu-holder--is-disabled': this.isDisabled,
                }
            },
            option() {
                return {
                    value: {
                        referral: this.referral,
                    },
                }
            },
        },

        methods: {
            openContextMenu(event) {
                if (this.isDisabled) {
                    return
                }
                const newEvent = {
                    originalEvent: event,
                    key: 'ctx-menu',
                }
                this.toggleReferralContextMenu(newEvent)
            },
        },
    }
</script>
